import React from 'react'
import PropTypes from 'prop-types'
import { length } from 'ramda'
import useWindowSize from 'hooks/useWindowSize'
import { VECHICLE_TYPE_BUS } from 'utils/constants'
import ModuleSummary from './ModuleSummary'
import {
  ModulesContainer,
  ModuleCard,
} from './ChecPlusVehicleSummaryPane.style'

import { MEDIUM } from './constants'

const ChecPlusVehicleSummaryExpandedModulesContanier = ({
  vehicle,
  vehicleModules,
  selected,
  setSelected,
}) => {
  const { width: windowWidth } = useWindowSize()
  const numModules = length(vehicleModules) * 3

  const handleSetSelected = (name) => {
    const target = name === selected ? null : name
    setSelected(target)
  }

  return (
    <ModulesContainer windowWidth={windowWidth} expanded>
      {vehicleModules.map((module) => (
        <ModuleCard
          flexible
          size={MEDIUM}
          key={module.uri}
          selected={selected === module.id}
          onClick={() => handleSetSelected(module.id)}
          numberOfModules={numModules}
          data-testid="module-card"
        >
          <ModuleSummary
            serialNumber={vehicle.id}
            moduleName={module.id}
            size={MEDIUM}
            isSummaryViewExpanded
            isSchoolBus={vehicle.subType === VECHICLE_TYPE_BUS}
          />
        </ModuleCard>
      ))}
    </ModulesContainer>
  )
}

ChecPlusVehicleSummaryExpandedModulesContanier.propTypes = {
  vehicle: PropTypes.object,
  vehicleModules: PropTypes.array,
  className: PropTypes.string,
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setSelected: PropTypes.func,
}

export default ChecPlusVehicleSummaryExpandedModulesContanier
